import styled, { css } from 'styled-components';
import { ToolsProps } from './types';
import { flexGap } from '../../../utils/flexGap';

export interface ToolsHeaderProps {
	$expanded?: boolean;
	$isMobile?: boolean;
	onClick?: (evt: React.MouseEvent<HTMLDivElement>) => void;
}

export const ToolsHeaderContainer = styled.div`
	cursor: pointer;
	padding-top: 9px;
	padding-bottom: 9px;
`;

export const ToolsHeaderContent = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const ToolsHeaderSeparator = styled.div`
	${({ theme }) => css`
		height: 2px;
		width: 100%;
		background-color: ${theme.colors.neutral[400]};
		margin-top: 3px;
		margin-bottom: 11px;
		border-radius: ${theme.radii.m};
	`};
`;

export const ToolsContentContainer = styled.div<ToolsProps>`
	${({ size }) => css`
		height: ${size}vh;
		max-height: ${size}vh;
		height: calc(var(--vh, 1vh) * ${size});
		max-height: calc(var(--vh, 1vh) * ${size});

		padding-bottom: 25px;
	`};
`;

export const ToolItem = styled.div<ToolsHeaderProps>`
	${({ theme, $isMobile, $expanded }) => css`
		${!$isMobile && 'width: 118px;'}
		${$isMobile && 'margin-right: 22px;'}
		height: 51px;
		display: flex;
		place-content: center;
		place-items: center;

		@media ${theme.screens.screenGTS} {
			${$expanded &&
			`
			border-radius: ${theme.radii.m};
		`};
		}
	`};
`;

export const ToolItemName = styled.div<{$bold?: boolean;}>`
	${({ theme, $bold }) => css`
		color: ${$bold ? theme.colors.neutral[500] : theme.colors.neutral[400]};
		font-size: ${theme.fontSizes.default};
		font-weight: ${theme.fontWeights.regular};
		text-align: center;
	`};
`;

export const ToolsInfo = styled.div`
	${({ theme }) => css`
		color: ${theme.colors.neutral[400]};
		font-size: ${theme.fontSizes.s};
		font-weight: ${theme.fontWeights.regular};
	`};
`;

export const ToolsInfoItem = styled.div`
	display: flex;
	flex-direction: row;
	${flexGap('8px', true)}
	align-items: center;
`;

export const Separator = styled.div`
	${({ theme }) => css`
		height: 28px;
		width: 1px;
		background-color: ${theme.colors.neutral[300]};
	`};
`;

export const ToolsExpand = styled.div`
	${({ theme }) => css`
		display: grid;
		place-content: center;
		background-color: ${theme.colors.neutral[200]};
		height: 34px;
		width: 34px;
		border-radius: ${theme.radii.m};
	`};
`;

export const ToolsOptions = styled.div`
	${({ theme }) => css`
		display: grid;
		place-content: center;
		background-color: ${theme.colors.neutral[200]};
		height: 34px;
		width: 34px;
		border-radius: ${theme.radii.m};
	`};
`;

export const ToolIcon = styled.div<{$expanded?: boolean}>`
	${({ theme, $expanded }) => css`
		position: relative;
		display: grid;
		place-content: center;
		width: 42px;
		height: 42px;
		border-radius: ${theme.radii.m};
		${$expanded && `background-color: ${theme.colors.neutral[200]};`}

		@media ${theme.screens.screenGTS} {
			width: 28px;
			height: 28px;
			background-color: transparent;
		}
	`};
`;

export const NotificationDot = styled.div`
	${({ theme }) => css`
		width: 7px;
		height: 7px;
		background-color: #ed576b;
		border-radius: ${theme.radii.l};
		position: absolute;
		right: 8px;
		bottom: 12px;

		@media ${theme.screens.screenGTS} {
			right: 1px;
			bottom: 6px;
		}
	`};
`;
